import { render, staticRenderFns } from "./ProceduresList.vue?vue&type=template&id=3be0c6a1&scoped=true&lang=pug"
import script from "./ProceduresList.vue?vue&type=script&lang=js"
export * from "./ProceduresList.vue?vue&type=script&lang=js"
import style0 from "./ProceduresList.vue?vue&type=style&index=0&id=3be0c6a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0c6a1",
  null
  
)

export default component.exports